module.exports = __webpack_public_path__ + "media/images/juju-transparent-logo-b42a02f199a722312e1a18b39e8011c0.png";